import React, { PureComponent } from "react";

import styled from "styled-components";

import { TextArea, Input } from "../Form/TextInput/TextInput";
import { Label } from "../Form/Label/Label";
import { breakpoints } from "../Grid/breakpoints";
import { Grid } from "../Grid/Grid";
import { Column } from "../Grid/Column";

import SweetAlert from "sweetalert-react";

import { Container } from "../Grid/Container";

import { EmojiPicker } from "../EmojiPicker/EmojiPicker";
import MapWrapper from "../MapWrapper/MapWrapper";
import EmojiMarker from "../EmojiMarker/EmojiMarker";

const ErrorLabel = styled.p`
  color: red;
  font-size: 11px;
  font-weight: bold;
`;

// ------------------------------------
// Styles
// ------------------------------------

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding-top: 5px;
  position: relative;
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  margin: 0 auto;
  width: 100%;
  max-width: 100%;
  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    display: ${props => (props.disabled ? "block" : "none")};
    top: 0;
    left: 0;
  }

  @media (min-width: ${breakpoints.md}px) {
    min-height: 0;
  }
`;

const styleTextArea = `
  flex: 1;
  display: flex;
  min-height: 150px;

  @media (min-width: ${breakpoints.md}px) {
    flex: 0 1 auto;
  }
`;

const styleTitleInput = `
  textarea {
		height: auto;
	}

`;

const FormContainer = styled(Container)`
  background-color: #fafafa;
  margin-bottom: 50px;
`;

const NumberBox = styled.h2`
  color: white;
  background-color: black;
  padding: 10px;
  border-radius: 50px;
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: space-around;
  align-items: center;
  margin-left: 10px;
`;

const RemoveLink = styled.a`
  color: #ff6a6a;
  font-size: 12px;
  font-weight: bold;
`;

class EmojiForm extends PureComponent {
  state = {
    id: null,
    emoji: null,
    title: "",
    body: "",
    lat: null,
    lng: null,
    dirty: false,
    mapWidth: 500,
    mapHeight: 500,
    showConfirmation: false,
    bounds: [],
    valid: {
      lat: true,
      lng: true,
      title: true,
      body: true,
      emoji: true
    }
  };

  componentDidMount() {
    const { city } = this.props;

    this.fillState(this.props);

    const bounds = [];
    if (city && city.viewport_ne_lat) {
      bounds.push({ lat: city.viewport_ne_lat, lng: city.viewport_ne_lng });
      bounds.push({ lat: city.viewport_sw_lat, lng: city.viewport_sw_lng });
    } else {
      bounds.push({ lat: city.lat, lng: city.lng });
      bounds.push({ lat: city.lat - 0.01, lng: city.lng - 0.01 });
      bounds.push({ lat: city.lat + 0.01, lng: city.lng + 0.01 });
    }

    this.setState({ bounds });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.emoji !== this.props.emoji) {
      this.fillState(nextProps);
    }
  }

  fillState(props) {
    if (props.emoji) {
      const { id, emoji, title, body, lat, lng } = props.emoji;
      this.setState({ id, emoji, title, body, lat, lng });
    }
  }

  _onSelectEmoji(emoji) {
    this.setStateAndSendChange({ emoji });
  }

  validate() {
    const { valid } = this.state;
    const required_fields = ["lat", "lng", "emoji"];
    const string_fields = ["title"];

    let isValid = true;
    let validObj = { ...valid };

    required_fields.forEach(f => {
      if (!this.state[f]) {
        validObj[f] = false;
        isValid = false;
      } else {
        validObj[f] = true;
      }
    });

    string_fields.forEach(f => {
      if (!this.state[f] || !this.state[f].length) {
        validObj[f] = false;
        isValid = false;
      } else {
        validObj[f] = true;
      }
    });

    this.setState({ valid: validObj });

    return isValid;
  }

  setStateAndSendChange(obj) {
    const { onChange } = this.props;
    let dirty = true;
    if (
      (obj.title === "" || !obj.title) &&
      (obj.body === "" || !obj.body) &&
      !obj.lat &&
      !obj.lng &&
      !obj.emoji
    ) {
      dirty = false;
    }

    this.setState({ ...obj, dirty }, () => {
      if (onChange) {
        onChange(this.state, this.validate());
      }
    });
  }

  pickValue(key, def = null) {
    const { emoji } = this.props;
    return this.state[key] ? this.state[key] : emoji ? emoji[key] : def;
  }

  removeEmoji(e) {
    this.setStateAndSendChange({
      title: null,
      body: null,
      lat: null,
      lng: null,
      emoji: null,
      toRemove: true
    });
  }

  render() {
    const { city, number, showErrors } = this.props;
    const { valid, id, dirty, showConfirmation, toRemove, bounds } = this.state;

    const title = this.pickValue("title") || "";
    const body = this.pickValue("body") || "";
    const emoji = this.pickValue("emoji");
    const lat = this.pickValue("lat");
    const lng = this.pickValue("lng");

    return (
      <FormContainer>
        <Form>
          <Grid>
            <Column size={1}>
              <NumberBox>{number}</NumberBox>
            </Column>
            <Column size={5} style={{ marginTop: "20px" }}>
              <Grid>
                <Label>Kies een emoji die bij het voorstel past: *</Label>

                <EmojiPicker
                  defaultValue={emoji}
                  onSelect={emoji => this._onSelectEmoji(emoji)}
                />

                {showErrors && !valid["emoji"] ? (
                  <ErrorLabel>Kies een emoji</ErrorLabel>
                ) : (
                  ""
                )}

                <Input
                  styleControl={styleTitleInput}
                  label="Titel *"
                  placeholder="Geef uw voorstel een wervende titel"
                  maxLength={100}
                  name="title"
                  error={showErrors && !valid["title"]}
                  onChange={e =>
                    this.setStateAndSendChange({ title: e.target.value })
                  }
                  value={title}
                />
              </Grid>
              <Grid>
                <TextArea
                  styleControl={styleTextArea}
                  label="Beschrijf uw voorstel in max. 250 tekens"
                  placeholder="Ik stel voor dat..."
                  name="body"
                  maxLength={250}
                  onChange={e =>
                    this.setStateAndSendChange({ body: e.target.value })
                  }
                  value={body}
                  disabled={false}
                />
              </Grid>
              <Grid>
                {(id && !toRemove) || dirty ? (
                  <p>
                    <RemoveLink
                      href="#"
                      onClick={e => {
                        e.preventDefault();
                        this.setState({ showConfirmation: true });
                      }}
                    >
                      Verwijder deze emoji
                    </RemoveLink>
                  </p>
                ) : null}
              </Grid>
            </Column>
            <Column size={6}>
              <MapWrapper
                height={`500px`}
                enableSearchBox={true}
                onSelect={({ lat, lng }) => {
                  this.setStateAndSendChange({ lat, lng });
                }}
                query={city.viewport_ne_lat ? null : city.name}
                city={city.name}
                initialBounds={bounds}
                defaultOptions={{
                  disableDefaultUI: true,
                  streetViewControl: false,
                  zoomControl: true
                }}
              >
                {lat && lng ? (
                  <EmojiMarker
                    emoji={{ lat, lng, emoji: emoji ? emoji : "?" }}
                  />
                ) : null}
              </MapWrapper>

              {showErrors && (!valid["lat"] || !valid["lng"]) ? (
                <ErrorLabel>Locatie is verplicht</ErrorLabel>
              ) : (
                ""
              )}
            </Column>
          </Grid>
        </Form>
        <SweetAlert
          show={showConfirmation}
          title="Ben je zeker?"
          text={`Ben je 100% zeker dat je deze emoji ${
            title ? `(${title})` : null
          } wil verwijderen?`}
          onConfirm={() => {
            this.setState({ showConfirmation: false });

            this.removeEmoji();
          }}
        />
      </FormContainer>
    );
  }
}

export default EmojiForm;



// WEBPACK FOOTER //
// ./src/components/AdminForm/EmojiForm.js